import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  container: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px 16px 40px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  title: {
    fontWeight: 700,
    fontSize: '22px',
  },
  filters: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    flexWrap: 'wrap' as any,
    background: '#2C325C',
    borderRadius: '12px',
    padding: '16px 20px',
    marginBottom: '16px',
  },
  paper: {
    background: '#2C325C',
    borderRadius: '12px',
    overflow: 'hidden',
    '& .MuiTableContainer-root': {
      borderRadius: '12px',
    },
  },
  table: {
    minWidth: 650,
    '& .MuiTableHead-root .MuiTableCell-root': {
      borderBottom: '1px solid #ffffff15',
      color: '#ffffffcc',
      fontSize: '13px',
      fontWeight: 600,
      padding: '12px 16px',
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      borderBottom: '1px solid #ffffff08',
      padding: '10px 16px',
      fontSize: '13px',
    },
  },
  row: {
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#ffffff0a',
    },
  },
  pagination: {
    borderTop: '1px solid #ffffff10',
    '& .MuiTablePagination-toolbar': {
      color: '#ffffff99',
    },
  },
});
